import { SET_YEBFROM_PAGE, SET_JBFROM_PAGE } from "@/store/mutation_types";

const routeHistory = {
  state: {
    yebFrom: "",
    jbFrom: ""
  },
  getters: {
    yebFrom: state => state.yebFrom,
    jbFrom: state => state.jbFrom
  },
  mutations: {
    [SET_YEBFROM_PAGE]: (state, data) => {
      state.yebFrom = data;
    },
    [SET_JBFROM_PAGE]: (state, data) => {
      state.jbFrom = data;
    }
  }
};
export default routeHistory;
